export default __webpack_public_path__ + "static/media/BEE6BE67-00.854d987c.png";